<template>
  <div class="content">
    <!--甲乙信息-->
    <div class="content-box content-party">
      <!-- <el-form
        :model="form"
        ref="form"
        label-position="top"
        :rules="rules"
      > -->
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_contract_personParty_agreement.htjbxx')}}
          </p>
          <el-form
            :model="form.baseInfo"
            ref="formBaseInfo"
            label-position="top"
          >
            <div class="form-container info-container">
              <el-row :gutter="16">
                <el-col :span="12" >
                  <el-form-item :label="$t('crm_contract_personParty_agreement.he_tong_lei_xing')"  prop="contractType" :rules="rules.contractType">
                    <custom-select
                      v-model="form.baseInfo.contractType"
                      code="crm_contract_type"
                      width="100%"
                      :disabled="true"
                    ></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" >
                  <el-form-item :label="$t('crm_contract_personParty_agreement.qian_ding_fang_shi')" prop="signingMethod" :rules="rules.signingMethod">
                    <custom-select
                      v-model="form.baseInfo.signingMethod"
                      code="signing_method"
                      width="100%"
                      :disabled="true"
                    ></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" >
                  <el-form-item
                    :label="$t('crm_contract_personParty_agreement.sghth')"
                    prop="customContractNo"
                    :rules="form.baseInfo.signingMethod==='2'?rules.customContractNo:[]"
                  >
                    <el-input
                      v-model="form.baseInfo.customContractNo"
                      style="width:100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('crm_contract_personParty_agreement.qian_ding_ri_qi')" prop="signingDate" :rules="form.baseInfo.signingMethod==='2'?rules.signingDate:[]"  >
                    <custom-date-picker
                      v-model="form.baseInfo.signingDate"
                      type="date"
                      align="right"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      default-time="00:00:00"
                      :picker-options="pickerOptionDay"
                      style="width:100%"
                    ></custom-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('crm_contract_personParty_agreement.qdscy')" prop="signingDuration" :rules="rules.signingDuration">
                    <el-input
                      v-model.number="form.baseInfo.signingDuration"
                      style="width:100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_contract_personParty_agreement.jia_yi_fang_xin_xi') }}
          </p>
          <el-form
            :model="form.partnerInfo"
            ref="formPartnerInfo"
            label-position="top"
          >
            <div class="form-container">
              <el-row>
                <el-col :span="12" class="party-a">
                  <div class="title">
                    <span>{{ $t('crm_contract_personParty_agreement.jia_fang_xin_xi')}}</span>
                  </div>
                  <!-- {{form.partnerInfo.businessLicense}} -->
                  <div class="party-form">
                    <el-form-item
                      :label="$t('crm_contract_personParty_agreement.jfsqdb')"
                      prop="partyAName"
                      :rules="rules.partyAName"
                    >
                      <el-input
                        v-model="form.partnerInfo.partyANameCode"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                      <!-- <el-select></el-select> -->
                    </el-form-item>
                    <el-row :gutter="16">
                      <el-col :span="12" >
                        <el-form-item
                            :label="$t('crm_contract_personParty_agreement.ye_wu_fu_ze_ren')"
                            prop="salesman"
                            :rules="rules.salesman"
                          >
                          <custom-select
                            v-model="form.partnerInfo.salesman"
                            :auto="false"
                            url="roleGetUserList"
                            :listener="`${form.partnerInfo.partyAId || null}`"
                            width="100%"
                            filterable
                            :isDefault="!!isNeedRequest"
                            :props="{label:'realName',value:'realName'}"
                            :params="{orgId:form.partnerInfo.partyAId,roleCode:'SYS_ROLE_SM'}"
                            @change="salesmanChange"
                            @getList="getSalesmanList"
                          ></custom-select>
                          </el-form-item>
                      </el-col>
                        <el-col :span="12" >
                          <el-form-item
                            :label="$t('crm_contract_personParty_agreement.ywfzrdh')"
                            prop="salesmanPhone"
                            :rules="rules.salesmanPhone"
                          >
                            <el-input
                              v-model="form.partnerInfo.salesmanPhone"
                              style="width:100%;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item :label="$t('crm_contract_personParty_agreement.sqdbdz')"  prop="partyAAddress" :rules="rules.partyAAddress">
                      <el-input
                        type="textarea"
                        v-model="form.partnerInfo.partyAAddress"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12" class="party-b">
                  <div class="title">
                    <span>{{ $t('crm_contract_personParty_agreement.yi_fang_xin_xi')}}</span>
                  </div>
                  <div class="party-form">
                    <el-form-item
                      :label="$t('crm_contract_personParty_agreement.yi_fang')"
                      prop="customerId"
                      :rules="rules.customerId"
                    >
                      <custom-select
                        ref="customerSelect"
                        v-model="form.partnerInfo.customerId"
                        :auto="false"
                        url="crmsCrmPartnerGetLargeCustomerList"
                        :listener="`${form.partnerInfo.customerName}${isNeedRequest}`"
                        width="100%"
                        filterable
                        remote
                        :props="{label:'partnerNameCode',value:'partnerOrgId'}"
                        :params="{num:50,keyword:form.partnerInfo.customerName}"
                        @change="partyBChange"
                        @clear="onCustomerClear"
                      ></custom-select>
                      <!-- :props="{label:'partnerName',value:'partnerOrgId'}" -->
                    </el-form-item>
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item
                          :label="$t('crm_contract_personParty_agreement.xiang_mu_fu_ze_ren')"
                          prop="projectContactName"
                          :rules="rules.projectContactName"
                        >
                          <!-- <el-input
                            v-model="form.partnerInfo.projectContactName"
                            style="width:100%;"
                          ></el-input> -->
                          <custom-select
                            v-model="form.partnerInfo.projectContactName"
                            :auto="false"
                            url="partnerContact"
                            :listener="`${form.partnerInfo.customerId || null}`"
                            width="100%"
                            filterable
                            allowCreate
                            defaultFirstOption
                            :isDefault="!!isNeedRequest"
                            :props="{label:'contactName',value:'contactName'}"
                            :params="{partnerOrgId:form.partnerInfo.customerId,contactType:'coopcontact'}"
                            @change="projectContactNameChange"
                          ></custom-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          :label="$t('crm_contract_personParty_agreement.lian_xi_dian_hua')"
                          prop="projectContactPhone"
                          :rules="rules.projectContactPhone"
                        >
                          <el-input
                            v-model="form.partnerInfo.projectContactPhone"
                            style="width:100%;"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="16">
                      <!-- 暂时没字段 -->
                      <el-col :span="12">
                        <el-form-item
                          :label="$t('crm_contract_personParty_agreement.shou_quan_dai_biao')"
                          prop="signerName"
                          :rules="rules.signerName"
                        >
                          <el-input
                            v-model="form.partnerInfo.signerName"
                            style="width:100%;"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          :label="$t('crm_contract_personParty_agreement.lian_xi_dian_hua')"
                          prop="signerPhone"
                          :rules="rules.signerPhone"
                        >
                          <el-input
                            v-model="form.partnerInfo.signerPhone"
                            style="width:100%;"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <!-- <el-form-item :label="$t('label_customer_bigCustomerName')" :rules="rules.bigCustomerName">
                      <el-input
                        v-model="form.partnerInfo.bigCustomerName"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                    </el-form-item> -->
                    <el-form-item :label="$t('crm_contract_personParty_agreement.fa_ren_xing_ming')" :rules="rules.legalPerson">
                      <el-input
                        v-model="form.partnerInfo.legalPerson"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('crm_contract_personParty_agreement.frsfzh')" :rules="rules.identityCard">
                      <el-input
                        v-model="form.partnerInfo.identityCard"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('crm_contract_personParty_agreement.yi_fang_di_zhi')" :rules="rules.customerAddress">
                      <el-input
                        type="textarea"
                        v-model="form.partnerInfo.customerAddress"
                        :disabled="true"
                        style="width:100%;"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <el-button type="primary" @click="saveform">{{$t('crm_contract_personParty_agreement.xybxzzlfahhcxx')}}</el-button>
    </div>

    <!-- 选择地址 -->
    <contractManagement-chooseAddress-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="addAddress"
    ></contractManagement-chooseAddress-dialog>
    <!--添加银行卡-->
    <bankcard-address-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="refreshBankcardList">
    </bankcard-address-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import tUpload from '@/components/upload.vue';
import bankcardAddressDialog from '@/pages/crm/components/bankCardDialog.vue';
import contractManagementChooseAddressDialog from '@/pages/crm/components/chooseAddressDialog.vue';

export default {
  components: { contractManagementChooseAddressDialog, bankcardAddressDialog },
  props: {
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number], // 唯一标识
    isCopy: { type: Boolean, default: false },
  },
  inject: ['getContractInfo'],
  computed: {
    rules() {
      return {
        // baseInfo: {
        contractType: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzhtlx') }, // 合同类型，数据字典：crm_contract_type
        signingMethod: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzqdfs') }, // 签订方式，字典分组代码：signing_method
        customContractNo: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxsghth') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], // 手工合同号
        signingDate: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzqdrq') }, // 签订日期
        signingDuration: [
          { required: true, type: 'number', message: this.$t('crm_contract_personParty_agreement.qtxqdsc') },
          {
            type: 'number',
            min: 0,
            message: this.$t('crm_contract_personParty_agreement.qdscbnxy0')
          },
        ], // 签订时长（月）
        usageScene: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qxzyycj') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], // 使用场景，数据字典：crm_contract_usage_scene
        contractTempId: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzhtqdmb') }, // 合同模板id
        projectId: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzssxm') }, // 项目名称Id
        // schemeType: { required: true, message: '请选择合同方案' }, // 合同方案，数据字典：crm_scheme_contract_type
        // deliveryDate: { required: true, message: '请选择交货日期' }, // 交货日期
        address: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzsydz') }, // 使用地址
        useAddress: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qxzxxdz') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }
        ], // 详细地址
        // },
        // partnerInfo: {
        // 甲方
        partyAName: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzjfsqdb') }, // 甲方授权代表
        salesman: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxywfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], // 业务负责人
        salesmanPhone: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qxzywfzrdh') },
          { validator: null, message: this.$t('crm_contract_personParty_agreement.cdyz713gzf') }
        ], // 业务负责人电话
        // 账号
        partyADepositNumber: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzzh') }, // 甲方授权代表银行卡号码
        partyADepositName: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzyhmc') }, // 甲方授权代表银行卡开户名
        partyADepositBank: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzzhmc') }, // 甲方授权代表银行卡开户支行

        // 乙方
        customerId: [{ required: true, message: this.$t('crm_contract_personParty_agreement.qtxyfsqdb') }], // 乙方授权代表
        projectContactName: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxyfxmfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], // 乙方项目负责人
        projectContactPhone: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxyfxmfzrlxdh') },
          { validator: null, message: this.$t('crm_contract_personParty_agreement.cdyz713gzf') }
        ], // 联系电话

        signerName: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxyfsqdb') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], //  乙方授权代表
        signerPhone: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxyfsqlxdh') },
          { validator: null, message: this.$t('crm_contract_personParty_agreement.cdyz713gzf') }
        ], // 乙方授权联系电话

        // bigCustomerName: { required: true, message: '请选择所属集团名称' }, // 所属集团名称
        // legalPerson: { required: true, message: '请选择法人' }, // 法人
        // identityCard: { required: true, message: '请选择法人身份证' }, // 法人身份证
        // registeredCapital: { required: true, message: '请选择注册资金' }, // 注册资金
        // customerAddress: { required: true, message: '请选择售后乙方地址' }, // 售后乙方地址
        cdeliverAddressId: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzshgsdz') }, // 售后公司地址
        // businessLicense: { required: true, message: '请选择营业执照' }, // 营业执照
        // },
        // afterService: {
        afterServiceId: { required: true, message: this.$t('crm_contract_personParty_agreement.qxzshgs') }, // 售后公司Id
        // afterServiceName: { required: true, message: '请填写乙方授权联系电话' }, // 售后公司
        // technicianId: { required: true, message: '请填写乙方授权联系电话' }, // 售后负责人Id
        technicianName: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxshfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), }
        ], // 售后负责人
        technicianPhone: [
          { required: true, message: this.$t('crm_contract_personParty_agreement.qtxshfzrdh') }, // 售后负责人电话
          { validator: null, message: this.$t('crm_contract_personParty_agreement.cdyz713gzf') }
        ], // 售后负责人电话
        // technicianEmail: { required: true, message: '请填写售后负责人邮箱' }, // 售后负责人邮箱
        sdeliverAddressId: { required: true, message: this.$t('crm_contract_personParty_agreement.qtxshgsdz') }, // 售后公司地址
        // sdeliverAddressVersion: { required: true, message: '请填写乙方授权联系电话' }, //
        // }

      };
    },
    contractInfo() {
      return this.getContractInfo();
    },
  },
  watch: {
    contractInfo: function () {
      this.setContractInfo();
    },
    // 乙方ID被清空时，主动请求一次下拉接口刷新列表（避免清空后无数据可选）
    'form.partnerInfo.customerId': function (val, oldVal) {
      if (!val && oldVal) {
        this.requestCustomerList();
      }
    },
  },
  data() {
    // 密码验证
    return {
      form: {
        baseInfo: {
          contractType: '30', // 合同类型，数据字典：crm_contract_type
          signingMethod: '2', // 签订方式，字典分组代码：signing_method
          // schemeType: '', // 合同方案，数据字典：crm_scheme_contract_type

          customContractNo: '', // 手工合同号
          // deliveryDate: '', // 交货日期
          signingDuration: '', // 签订时间
          // projectId: '', // 项目名称Id
          // projectName: '', // 项目名称

          signingDate: '', // 签订日期
          // usageScene: '', // 使用场景，数据字典：crm_contract_usage_scene
          // address: [], // 使用地址
          // useAddress: '', // 使用地点

          // contractTempId: '', // 模板id

          // city: '', // 所属城市
          // cityCode: '', // 所属城市代码
          // province: '', // 所属省份
          // provinceCode: '', // 所属省份代码
          // country: '', // 所属国家
          // countryCode: '', // 所属国家编码
        },
        partnerInfo: {
          partyAId: '', // 甲方授权代表ID"
          partyAName: '', // 甲方授权代表名称"
          partyACode: '', // 甲方授权编码
          partyANameCode: '', // 甲方授权编码名字
          salesman: '', // 业务负责人
          salesmanPhone: '', // 业务负责人电话
          salesmanId: '', // 业务负责人ID
          partyAAddress: '', // 授权代表地址
          // partyADepositNumber: '', // 账号
          // partyADepositName: '', // 银行名称
          // partyADepositBank: '', // 支行名称
          partyABizId: '', // 甲方授权代表ID"


          customerId: '', // 乙方授权代表
          customerCode: '', // 乙方编码
          customerName: '', // 乙方名称
          partnerOrgId: '', // 乙方orgId
          // businessLicense: '', // 营业执照用于预览合同

          projectContactName: '', // 乙方项目负责人
          projectContactPhone: '', // 联系电话
          signerName: '', // 授权代表
          signerPhone: '', // 联系电话
          // identityCard: '', // 法人身份证号
          customerAddress: '', // 乙方地址
          bigCustomerId: '', // 大客户Id
          bigCustomerName: '', // 大客户名称

          // 地址id
          // bizId: '',
          // // 新加的
          // businessLicense: '', // 营业执照用于预览合同
          legalPerson: '', // 法人
          identityCard: '', // 法人身份证
          // registeredCapital: '', // 注册资金

          // 乙方地址
          // cdeliverAddressId: '', // 收货id
          // cdeliverAddressVersion: '', // 地址版本
          // isDefault: '', // 是否默认
          // consigneeName: '', // 收货人
          // consigneePhone: '', // 收货人电话
          // detailAddress: '', // 详细地址


        },
        // afterService: {
        //   afterServiceId: '', // 售后公司Id
        //   afterServiceName: '', // 售后公司
        //   sdeliverAddressId: '', //
        //   sdeliverAddressVersion: '', //
        //   technicianId: '', // 售后负责人Id
        //   technicianName: '', // 售后负责人名称
        //   technicianPhone: '', // 售后负责人电话

        //   // 售后地址
        //   isDefault: '',
        //   consigneeName: '',
        //   consigneePhone: '',
        //   detailAddress: '',
        //   // 地址id
        //   bizId: '',

        // },

        bizId: '', // 合同ID，编辑时必填
        bizClass: '20', // 合同类型 数据字典 crm_contract_class_type
        operateFlag: '', // 操作的唯一标识，标识一次连续的操作

        // 合同列表类型
        contractClassType: [],
        contractClassTypeList: []
      },

      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 更新下拉
      projectListFlag: '0',
      edit: false,
      // 公司ID
      // contractId: '',
      partyAList: [],

      // 新建项目
      dialogVisible1: '',
      dialogModel1: {},

      // 选择收货地址
      dialogVisible2: false,
      dialogModel2: {},
      BankcardListFlag: '0',
      // 编辑就为false  新增为true 避免重复调用公司的覆盖问题
      isNeedRequest: '',

      // 乙方下拉：清空后需要补拉取一次下拉数据，避免下拉列表为空无法重新选择
      customerSelectRequesting: false,
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

    // 获取甲方信息（当前登录人所属组织）
    // this.getPartyA();

    // 获取详情
    // this.getContractDetail();
    setTimeout(() => {
      this.setContractInfo();
    }, 300);
    if (this.$route.path.indexOf('edit') > -1) {
      this.edit = true;
    }
    // this.getOssConfig();
    this.getDictionary('crm_contract_class_type', (data) => {
      const list = data['crm_contract_class_type'];
      this.form.contractClassTypeList = list.filter(i => i.value === this.form.bizClass);
    });

    this.formRule();
  },
  methods: {
    // 乙方下拉：补请求一次下拉接口（带简单去重），用于 customerId 被清空的场景
    requestCustomerList() {
      if (this.customerSelectRequesting) {
        return;
      }
      this.customerSelectRequesting = true;

      this.$nextTick(() => {
        setTimeout(() => {
          const selectRef = this.$refs.customerSelect;
          if (selectRef && typeof selectRef.getSelectList === 'function') {
            selectRef.getSelectList();
          }
          this.customerSelectRequesting = false;
        }, 50);
      });
    },
    onCustomerClear() {
      // 用户手动点清空乙方时，也补拉一次下拉数据
      this.requestCustomerList();
    },
    formRule: function () {
      this.rules.salesmanPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.projectContactPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.signerPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.technicianPhone[1].validator = this.$mobilePhoneValidator;
    },
    setContractInfo: function () {
      if (!this.contractId) {
        // 获取乙方信息（租赁方） 新增才需要调用
        // this.getCustomerList();
        // 获取甲方信息（当前登录人所属组织）新增才需要调用
        this.getPartyA();
        this.isNeedRequest = true;
        return;
      }

      const data = this.contractInfo;
      // this.$setFormatData(this.form, data);
      this.$setFormatData(this.form.baseInfo, data);
      this.$setFormatData(this.form.partnerInfo, data);
      this.form.partnerInfo.partyANameCode = `${this.form.partnerInfo.partyACode}${this.form.partnerInfo.partyACode ? '/' : ''}${this.form.partnerInfo.partyAName}`;
      // 拷贝合同 手工合同号 签订日期重置
      if (this.isCopy) {
        this.form.baseInfo.customContractNo = '';
        this.form.baseInfo.signingDate = '';
        this.form.baseInfo.deliveryDate = '';
      }
      // this.form.baseInfo.signingDuration = +data.signingDuration;
      this.form.baseInfo.signingDuration = this.form.baseInfo.signingDuration ? +data.signingDuration : '';
      // 修改
      // 合同类型
      this.form.baseInfo.contractType = `${this.form.baseInfo.contractType}`;
      // 签订方式
      // this.form.baseInfo.signingMethod = `${data.signingMethod}`;
      // 因为没有电子合同先写死是纸质合同
      this.form.baseInfo.signingMethod = '2';
      // 银行卡
      // this.form.partnerInfo.partyADepositNumber = this.contractInfo.partyADepositNumber; // 甲方授权代表银行卡号码
      // this.form.partnerInfo.partyADepositName = this.contractInfo.partyADepositName; // 甲方授权代表银行卡开户名
      // this.form.partnerInfo.partyADepositBank = this.contractInfo.partyADepositBank; // 甲方授权代表银行卡开户支行
      // 乙方地址 cdeliverAddress

      // 地址ID
      this.form.partnerInfo.partnerOrgId = data.customerId; //
      this.isNeedRequest = false;
      if (
        data.cdeliverAddress
            && Object.keys(data.cdeliverAddress).length !== 0
      ) {
        // this.form.partnerInfo.deliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
        // this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
        // this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
        // this.form.partnerInfo.detailAddress = data.cdeliverAddress.detailAddress; // 详细街道地址


        this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
        this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
        this.form.partnerInfo.detailAddress = `${data.cdeliverAddress.country}${data.cdeliverAddress.province}${data.cdeliverAddress.city}${data.cdeliverAddress.detailAddress}`; // 详细地址
        // this.partyForm.version=data.cdeliverAddress. // 版本号
        // this.form.partnerInfo.isDefault = data.cdeliverAddress.isDefault || ''; // 是否默认
        // this.form.partnerInfo.cdeliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
        // this.form.partnerInfo.cdeliverAddressVersion = data.cdeliverAddress.version;// 地址版本


      }

    },

    // 合同类型下拉字典
    changeAddress: function (type) {
      if (type === 'PartyB') {
        if (this.form.partnerInfo.partnerOrgId) {
          this.dialogVisible = true;
          this.dialogModel.title = this.$t('crm_contract_personParty_agreement.xzyfsqdb');
          this.dialogModel.data = {
            partnerOrgId: this.form.partnerInfo.partnerOrgId,
            type: 'PartyB'
          };
        } else {
          this.$message({
            message: this.$t('crm_contract_personParty_agreement.qxxzyfsqdb'),
            type: 'error'
          });
        }
      } else {
        // service
        if (this.form.afterService.partnerOrgId) {
          this.dialogVisible = true;
          this.dialogModel.title = this.$t('crm_contract_personParty_agreement.xzshshdz');
          this.dialogModel.data = {
            partnerOrgId: this.form.afterService.partnerOrgId,
            type: 'service'
          };
        } else {
          this.$message({
            message: this.$t('crm_contract_personParty_agreement.qxxzshgs'),
            type: 'error'
          });
        }
      }

    },
    addAddress: function (arg) {
      const item = arg[0];
      if (this.dialogModel.data.type === 'PartyB') {
        // deliverAddressId
        this.form.partnerInfo.consigneeName = item.consigneeName; // 收货人
        this.form.partnerInfo.consigneePhone = item.consigneePhone; // 收货人电话
        this.form.partnerInfo.detailAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
        // this.partyForm.version=item. // 版本号
        this.form.partyForm.isDefault = item.isDefault || ''; // 是否默认
        this.form.partyForm.cdeliverAddressId = item.deliverAddressId; // 地址ID
        this.form.partyForm.cdeliverAddressVersion = item.version;// 地址版本
      } else {
        this.form.afterService.sdeliverAddressId = item.deliverAddressId; // 地址ID
        this.form.afterService.sdeliverAddressVersion = item.version; // 地址版本
        this.form.afterService.consigneeName = item.consigneeName; // 收货人
        this.form.afterService.consigneePhone = item.consigneePhone; // 收货人电话
        this.form.afterService.detailAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
        // this.partyForm.version=item. // 版本号
        this.form.afterService.isDefault = item.isDefault || ''; // 是否默认

      }
    },

    // 刷新项目下拉列表
    refreshProjectList: function () {
      this.projectListFlag += 1;
    },
    // 添加银行卡
    addBankCard: function () {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('crm_contract_personParty_agreement.tjyhkxx');
    },
    // 刷新银行卡下拉列表
    refreshBankcardList: function () {
      this.BankcardListFlag += 1;
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    // 保存甲方乙方
    saveform: function () {
      this.$refs.formBaseInfo.validate((valid1) => {
        if (!valid1) {
          return;
        }
        this.$refs.formPartnerInfo.validate((valid2) => {
          if (!valid2) {
            return;
          }
          this.form.operateFlag = this.operateFlag;
          this.form.bizId = this.contractId;
          this.form.bizClass = this.form.baseInfo.contractType;
          if (this.isCopy) {
            this.$postJSON(apis.crmContractCopy,
              this.form
            ).then((res) => {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success'
              });
              this.$emit('syncContractId', res.data, this.form.bizClass);
              this.$emit('success', 2);
            });
          } else if (this.contractId) {
            this.$postJSON(apis.contractUpdate,
              this.form
            ).then((res) => {
              this.$message({
                message: this.$t('Common.com_save_success'),
                type: 'success'
              });
              this.$emit('syncContractId', res.data, this.form.bizClass);
              this.$emit('success', 2);
            });
          } else {
            this.$postJSON(apis.contractAdd,
              this.form
            ).then((res) => {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success'
              });
              this.$emit('syncContractId', res.data, this.form.bizClass);
              this.$emit('success', 2);
            });
          }

        });
      });
    },
    partyBChange: function (item) {
      if (item) {
        // this.form.customerId = item.contactName || ''; // 乙方授权代表id
        // this.form.customerName = item.contactName || ''; // 乙方授权代表名称 自用
        this.form.partnerInfo.customerCode = item.partnerCode; // code 授权代表code
        this.form.partnerInfo.customerName = item.partnerName; // name 授权代表name
        // this.form.partnerInfo.projectContactName = item.busLeaderName || ''; // 项目负责人"
        // this.form.partnerInfo.projectContactPhone = item.busLeaderPhone || ''; // 联系电话
        // 下拉要清空
        this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = ''; // 联系电话
        this.form.partnerInfo.signerName = item.contactName || ''; // 授权代表
        this.form.partnerInfo.signerPhone = item.contactPhone || ''; // 联系电话
        // this.form.partnerInfo.identityCard = item.identityCard || ''; // 法人身份证号
        this.form.partnerInfo.customerAddress = item.address || ''; // 乙方地址
        this.form.partnerInfo.bigCustomerId = item.parentId || ''; // 上级大客户ID
        this.form.partnerInfo.bigCustomerName = item.parentName || ''; // 上级大客户名称
        // 地址ID
        this.form.partnerInfo.partnerOrgId = item.partnerOrgId; // 乙方地址id
        // 法人姓名 身份证
        this.form.partnerInfo.legalPerson = item.legalPerson;
        this.form.partnerInfo.identityCard = item.legalPersonIdentity;

        // 默认地址
        if (
          item.partnerDeliverAddress
        && Object.keys(item.partnerDeliverAddress).length !== 0
        ) {
          this.form.partnerInfo.cdeliverAddressId = item.partnerDeliverAddress.deliverAddressId; // 地址ID
          this.form.partnerInfo.cdeliverAddressVersion = item.partnerDeliverAddress.version;// 地址版本
          this.form.partnerInfo.consigneeName = item.partnerDeliverAddress.consigneeName; // 收货人
          this.form.partnerInfo.consigneePhone = item.partnerDeliverAddress.consigneePhone; // 收货人电话
          this.form.partnerInfo.detailAddress = `${item.partnerDeliverAddress.country}${item.partnerDeliverAddress.province}${item.partnerDeliverAddress.city}${item.partnerDeliverAddress.detailAddress}`; // 详细街道地址
        } else {
          this.form.partnerInfo.cdeliverAddressId = ''; // 地址ID
          this.form.partnerInfo.cdeliverAddressVersion = item.cdeliverAddressVersion;// 地址版本
          this.form.partnerInfo.consigneeName = ''; // 收货人
          this.form.partnerInfo.consigneePhone = ''; // 收货人电话
          this.form.partnerInfo.detailAddress = ''; // 详细街道地址
        }
      } else {
        // 清空
        this.form.partnerInfo.customerCode = ''; // code 授权代表code
        this.form.partnerInfo.customerName = ''; // name 授权代表name
        this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = ''; // 联系电话
        this.form.partnerInfo.signerName = ''; // 授权代表
        this.form.partnerInfo.signerPhone = ''; // 联系电话
        this.form.partnerInfo.customerAddress = ''; // 乙方地址
        this.form.partnerInfo.bigCustomerId = ''; // 上级大客户ID
        this.form.partnerInfo.bigCustomerName = ''; // 上级大客户名称
        // 地址ID
        this.form.partnerInfo.partnerOrgId = ''; // 乙方地址id
        // 法人姓名 身份证
        this.form.partnerInfo.legalPerson = '';
        this.form.partnerInfo.identityCard = '';

        this.form.partnerInfo.cdeliverAddressId = ''; // 地址ID
        this.form.partnerInfo.cdeliverAddressVersion = '';// 地址版本
        this.form.partnerInfo.consigneeName = ''; // 收货人
        this.form.partnerInfo.consigneePhone = ''; // 收货人电话
        this.form.partnerInfo.detailAddress = ''; // 详细街道地址
      }
      this.onProjectChange();
    },

    // 获取甲方信息（当前登录人所属组织）
    getPartyA: function () {
      this.$getJSON(apis.partnerGetPartyA).then((res) => {
        // this.projectList = res.data;
        // this.$setFormatData(this.form.partnerInfo, res.data);
        this.form.partnerInfo.partyAId = res.data.partnerOrgId; // 甲方授权代表
        this.form.partnerInfo.partyABizId = res.data.partnerId; // 甲方授权代表biBizId
        this.form.partnerInfo.partyAName = res.data.partnerName;
        this.form.partnerInfo.partyACode = res.data.partnerCode;
        this.form.partnerInfo.partyANameCode = `${this.form.partnerInfo.partyACode}${this.form.partnerInfo.partyACode ? '/' : ''}${this.form.partnerInfo.partyAName}`;
        this.form.partnerInfo.businessLicense = res.data.businessLicense;
        // this.form.partnerInfo.salesman = res.data.contactName || ''; // 甲方项目负责人
        // this.form.partnerInfo.salesman = res.data.contactName || ''; // 甲方项目负责人
        // this.form.partnerInfo.salesmanPhone = res.data.contactPhone || ''; // 联系电话
        this.form.partnerInfo.partyAAddress = res.data.address || '';

        // this.form.partnerInfo.partyADepositNumber = res.data.partyADepositNumber || ''; // 甲方授权代表银行卡号码
        // this.form.partnerInfo.partyADepositName = res.data.partyADepositName || ''; // 甲方授权代表银行卡开户名
        // this.form.partnerInfo.partyADepositBank = res.data.partyADepositBank || ''; // 甲方授权代表银行卡开户支行
        if (this.contractId) {
          const data = this.contractInfo;
          // this.$setFormatData(this.form, data);
          this.$setFormatData(this.form.baseInfo, data);
          this.$setFormatData(this.form.partnerInfo, data);
        }


      });
    },

    // 甲方业务负责人
    salesmanChange(item) {
      if (item && (this.isNeedRequest || this.form.partnerInfo.salesmanId !== item.userId)) {
        this.form.partnerInfo.salesman = item.realName || ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = item.mobile || ''; // 联系电话
        this.form.partnerInfo.salesmanId = item.userId || ''; // id
      } else {
        this.form.partnerInfo.salesman = !this.isNeedRequest ? this.form.partnerInfo.salesman : ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = !this.isNeedRequest ? this.form.partnerInfo.salesmanPhone : ''; // 联系电话
        this.form.partnerInfo.salesmanId = !this.isNeedRequest ? this.form.partnerInfo.salesmanId : '';// id
      }
    },
    // salesman匹配不上
    getSalesmanList(list) {
      if (!list.some(item => item.realName === this.form.partnerInfo.salesman)) {
        this.form.partnerInfo.salesman = ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = ''; // 联系电话
        this.form.partnerInfo.salesmanId = '';// id
      }
    },
    // 乙方项目负责人
    projectContactNameChange(item) {
      if (item && (this.isNeedRequest || this.form.partnerInfo.projectContactPhone !== item.mobilePhone)) {
        this.form.partnerInfo.projectContactName = item.contactName || ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = item.mobilePhone || ''; // 联系电话
      } else {
        // this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = !this.isNeedRequest ? this.form.partnerInfo.projectContactPhone : ''; // 联系电话
      }
    },
    // 模板下拉
    // onEcontractTemp: function (item) {
    //   // console.log(item);
    //   this.form.baseInfo.econtractTitle = item.title;
    //   // this.form.baseInfo.tempContent = item.tempContent;
    // },
    onProjectChange: function (item) {
      if (item && Object.keys(item).length) {
        this.form.baseInfo.locationName = item.locationName;
        this.form.baseInfo.locationId = item.locationId;
        // if (this.form.baseInfo.address.length === 0) {
        // this.form.baseInfo.address = [];
        // this.form.baseInfo.useAddress = '';
        // 只有为空才带出来
        if (item.countryCode) {
          this.form.baseInfo.address = [];
          this.form.baseInfo.address.push(item.countryCode);
        }
        if (item.provinceCode) {
          this.form.baseInfo.address.push(item.provinceCode);
        }
        if (item.cityCode) {
          this.form.baseInfo.address.push(item.cityCode);
        }
        if (item.detailAddress) {
          this.form.baseInfo.useAddress = item.detailAddress;
        }
        // }
      } else {
        this.form.baseInfo.locationName = '';
        this.form.baseInfo.locationId = '';
        this.form.baseInfo.address = [];
        this.form.baseInfo.useAddress = '';
      }
    },
    // 银行下拉
    onDepositNumber: function (item) {
      this.form.partnerInfo.partyADepositName = item.depositName;
      this.form.partnerInfo.partyADepositBank = item.depositBank;
    },

    // onGetBankList: function (list) {
    //   const defaultItem = list.find(i => i.isDefault) || [];
    //   if (Object.keys(defaultItem).length) {
    //     this.form.partnerInfo.partyADepositNumber = this.form.partnerInfo.partyADepositNumber || defaultItem.depositNumber;
    //     this.form.partnerInfo.partyADepositName = this.form.partnerInfo.partyADepositName || defaultItem.depositName;
    //     this.form.partnerInfo.partyADepositBank = this.form.partnerInfo.partyADepositBank || defaultItem.depositBank;
    //   }
    // },
    // onAfterServiceChange: function (item) {
    //   this.form.afterService.sdeliverAddressVersion = item.sdeliverAddressVersion;
    // },


    // 预览模板
    previewTemplate: function () {
      if (this.form.baseInfo.contractTempId) {
        this.$postJSON(apis.crmBestsginTemplatePreview, {
          tid: this.form.baseInfo.contractTempId,
          // account: '330106199508016666'
          account: this.form.partnerInfo.businessLicense
        }).then((res) => {
          // window.open(res.data.url);

          this.jumpNewTab(res.data.url);
        });
      } else {
        this.$message({
          message: this.$t('crm_contract_personParty_agreement.qxxzhtmb'),
          type: 'error'
        });
      }

    }
  },


};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-party{
  // padding:0px !important;
  padding: 0 24px;
  .form-box {
    margin-top: 35px;
    position: relative;
    width: 100%;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 35px 0 32px;
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .form-container{
      padding:0 24px ;
      width: 1100px;
      .party-a,
      .party-b,
      .contract-a,
      .contract-b {
        padding:0 24px ;
        width: 440px;
        box-sizing: content-box;
      }
      .party-b,
      .contract-b {
        border-left: 1px solid #eef2f8;
      }
      // 甲乙方信息
      .address-box {
        > h3 {
          color: #000;
          padding-bottom: 16px;
          line-height: 24px;
        }
        // .address-btn {
        //   border: 4px dashed #00afff;
        //   position: relative;
        //   height: 136px;
        //   line-height: 136px;
        //   text-align: center;
        //   font-size: 60px;
        //   color: rgba(0, 0, 0, 0.45);
        // }
        // .address-item {
        //   border: 4px dashed #00afff;
        //   position: relative;
        //   padding: 10px 0 0 10px;
        //   h3 {
        //     line-height: 40px;
        //     height: 40px;
        //     font-size: 14px;
        //     color: #1e1e1e;
        //     border-bottom: 1px solid #efefef;
        //   }
        //   p {
        //     font-size: 12px;
        //     line-height: 17px;
        //     color: #666;
        //     padding-top: 10px;
        //     height: 78px;
        //   }
          .address-modify-btn {
            position: absolute;
            bottom: 10px;
            font-size: 12px;
            color: #f33a73;
            cursor: pointer;
          }
        //   .address-default {
        //     position: absolute;
        //     top: 0;
        //     right: 0;
        //     font-size: 12px;
        //     color: #fff;
        //     padding: 0 13px;
        //     background: rgba(0, 0, 0, 0.19);
        //     border-radius: 0px 0px 0px 100px;
        //   }
        // }
      }
    }
    .info-container{
      width: 668px;
      padding:0 24px;
      box-sizing: content-box;
    }
  }


}


</style>
